<template>
  <main>
    <div class="report_item_page flex items-start">
      <report-sidebar
        :visible-page="visiblePage"
        @open-widget-modal="payload => { widgetModal = payload }"
      />

      <report-content />
    </div>
  </main>

  <a
    :class="[
      'plus_fixed_btn',
      liveChatEnabled ? 'live_chat_enabled' : '',
    ]"
    href="javascript:;"
    @click="openModal({modal: 'new', widget: null, pageId: visiblePage})"
  />
  <div class="back_to_top" />
</template>

<script>
import _ from 'lodash';
import Swal from 'sweetalert2';
import {mapActions, mapState} from 'vuex';
import ReportSidebar from './includes/ReportSidebar.vue';
import ReportContent from './includes/ReportContent.vue';

require("/components/jquery/dist/jquery.min.js");
require("/js/jquery-ui.min.js");
require("/components/jquery-circle-progress/circle-progress.js");
require("/components/loading-bar/loading-bar.js");
require("/components/jquery-tablesorter/jquery.tablesorter.min.js");
require("/components/rangeslider/range.min.js");
require("/js/tooltipster.bundle.min.js");
require("/js/reports/main.js");
//require("/js/reports/index.js");
require("/js/reports/report.js");

export default {
  components: {
    ReportSidebar,
    ReportContent
  },
  props: {
    reportId: {
      type: Number,
      required: true
    },
    template: {
      type: Boolean,
      required: true
    },
    liveChatEnabled: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      visiblePage: null
    }
  },
  computed: {
    ...mapState('report', ['report']),
    ...mapState('pages', ['pages'])
  },
  async mounted() {
    await this.getUser();
    await this.fetchReport({type: (this.template ? 'templates' : 'reports'), id: this.reportId});
    await this.getReportPages({type: (this.template ? 'templates' : 'reports'), id: this.reportId});
    this.throttleGetVisiblePage();
    document.addEventListener('scroll', () => {
      this.throttleGetVisiblePage();
    });
    if (this.report.is_template) {
      Swal.fire({
        title: `Dummy data!`,
        icon: 'info',
        html: `Whilst building templates, we use dummy data for all the widgets to give you a better feel for how they will look on a live report.<br>When you're ready to build a live report from this template head back over to the 'My Reports' dashboard and click 'Create Report'.`,
        confirmButtonText: 'Got it!',
        backdrop: true,
      })
    }
  },
  methods: {
    ...mapActions({
      fetchReport: 'report/fetchReport',
      getReportPages: 'pages/getReportPages',
      openModal: 'widgetModal/openModal',
      getUser: 'user/getUser'
    }),
    closeModal() {
      this.widgetModal = {id: null, widget: null, pageId: null}
    },
    throttleGetVisiblePage: _.debounce(function () {
      this.getVisiblePage();
    }, 50),
    getVisiblePage() {
      var pages = document.getElementsByClassName('page');
      var visiblePages = [];

      _.forEach(pages, page => {
        let data = {
          id: page.id,
          percentage: this.calculateVisibilityForPage(page)
        };
        visiblePages.push(data);
      });
      const focusedPage = _.maxBy(visiblePages, function (o) {
        return o.percentage
      });
      const id = focusedPage ? focusedPage.id.replace('p', '') : null;
      this.visiblePage = parseInt(id);
    },
    calculateVisibilityForPage: (page) => {
      var windowHeight = window.innerHeight,
          docScroll = document.documentElement.scrollTop,
          divPosition = (page.getBoundingClientRect().top + window.pageYOffset),
          divHeight = page.offsetHeight,
          hiddenBefore = docScroll - divPosition,
          hiddenAfter = (divPosition + divHeight) - (docScroll + windowHeight);
      if ((docScroll > divPosition + divHeight) || (divPosition > docScroll + windowHeight)) {
        return 0;
      } else {
        var result = 100;

        if (hiddenBefore > 0) {
          result -= (hiddenBefore * 100) / divHeight;
        }

        if (hiddenAfter > 0) {
          result -= (hiddenAfter * 100) / divHeight;
        }

        return result;
      }
    }
  }
}
</script>

<style scoped>
main {
  font-family: 'DM Sans', sans-serif;
  background-color: #F8F7F5;
}

.plus_fixed_btn {
  position: fixed;
  right: 2rem;
  bottom: 2rem;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  background-color: #37B2A8;
  background-image: url("data:image/svg+xml,%3Csvg width='26' height='28' viewBox='0 0 26 28' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.44434 13.9999H21.5554' stroke='white' stroke-width='3.55556' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M13.0005 5.03699V22.9629' stroke='white' stroke-width='3.55556' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
  background-size: auto;
  background-position: center;
  background-repeat: no-repeat;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
}

.plus_fixed_btn:hover {
  background-color: #216e68;
}

.plus_fixed_btn.live_chat_enabled {
    margin-bottom: 90px;
}

</style>




